import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';

@Injectable()
export class CustomPaginatorIntl extends MatPaginatorIntl {
  private translate: TranslateService;
  override changes = new Subject<void>();
  override itemsPerPageLabel = 'Items per page';
  override nextPageLabel = 'Next page';
  override previousPageLabel = 'Previous page';
  override firstPageLabel = 'First page';
  override lastPageLabel = 'Last page';

  constructor(translate: TranslateService) {
    super();
    this.translate = translate;
    this.translate.onLangChange.subscribe(() => {
      this.updateLabels();
    });
    this.updateLabels();
  }

  updateLabels() {
    this.translate.get('GRID.PAGINATOR.ITEMS_PER_PAGE').subscribe((res: string) => {
      this.itemsPerPageLabel = res;
      this.changes.next();
    });
    this.translate.get('GRID.PAGINATOR.NEXT_PAGE').subscribe((res: string) => {
      this.nextPageLabel = res;
      this.changes.next();
    });
    this.translate.get('GRID.PAGINATOR.PREVIOUS_PAGE').subscribe((res: string) => {
      this.previousPageLabel = res;
      this.changes.next();
    });
    this.translate.get('GRID.PAGINATOR.FIRST_PAGE').subscribe((res: string) => {
      this.firstPageLabel = res;
      this.changes.next();
    });
    this.translate.get('GRID.PAGINATOR.LAST_PAGE').subscribe((res: string) => {
      this.lastPageLabel = res;
      this.changes.next();
    });
  }

  override getRangeLabel = (page: number, pageSize: number, length: number) => {
    if (length === 0 || pageSize === 0) {
      return this.translate.instant('GRID.PAGINATOR.RANGE_PAGE', { start: 0, end: 0, length });
    }
    const startIndex = page * pageSize;
    const endIndex = startIndex < length ?
      Math.min(startIndex + pageSize, length) :
      startIndex + pageSize;
    return this.translate.instant('GRID.PAGINATOR.RANGE_PAGE', { start: startIndex + 1, end: endIndex, length });
  }
}
